import {QuestionReferences, BranchNode, validator} from "@reside/forms";
import {
  EventTriggerForm,
  TemplateField,
} from "../../services/HubAndSpokeService";
import unflatten from "obj-unflatten";

const VALIDATORS = {
  document_path: "required|document-path",
};

export const truncateAnswer = (answerText: string) =>
  answerText.length > 120 ? `${answerText.substring(0, 120)}...` : answerText;

export function CreateQuestionReferenceFromTemplateField(
  templateField: TemplateField,
): QuestionReferences<BranchNode> {
  return {
    id: templateField.question_id,
    type: templateField.question_type as any,
    translationKey: templateField.question_translation_text,
    choices: [
      {
        id: templateField.answer_id,
        translationKey: templateField.answer_translation_text,
      },
    ],
  };
}

export function CreateFormControlWithReference(
  reference: QuestionReferences<BranchNode>,
) {
  return {
    id: `form:control-${reference.id}`,
    type: "form:control",
    reference,
    name: `form:control-${reference.id}`,
    state: {
      visible: true,
    },
  };
}

export const validate = (formValues: EventTriggerForm) => {
  return unflatten(validator.validateAll(formValues, VALIDATORS));
};
